import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import i18n from '../../../../../constants/initLng';
import { useTranslation } from "react-i18next";
import * as CPN from "antd";
import * as Func from "../../../../../helpers/functions";
import {getLocaleFullName} from "../../../../../utils/commonUtils";
import Modal from '../../../common/component/Modal';
import Dropdown from '../../../common/component/Dropdown';
import { PATHS } from '../../../../../constants/Define';

export const EditComponent = (props) => {

    const { t } = useTranslation();

    const removeUser = () => {
        props.onDeleteUser({ id: props.item.id })
    }
    const onRemove = () => {
        const { confirm } = Modal;
        confirm({
            title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.user.title`)),
            content: getLocaleFullName(props.item.firstname, props.item.lastname),
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: removeUser,
        });
    };

    return (
        <Fragment>
            <Dropdown overlay={
                <CPN.Menu className="action-menu">
                    {
                        props.permisionActions && props.permisionActions.allowUpdate &&
                        <CPN.Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.USER.DETAIL.path, { id: props.item.id })} className={`mr-2`}>
                                <CPN.Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                            </Link>
                        </CPN.Menu.Item>
                    }

                    {
                        props.permisionActions && props.permisionActions.allowDelete &&
                        <CPN.Menu.Item onClick={onRemove}><CPN.Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</CPN.Menu.Item>
                    }
                </CPN.Menu>
            }>
                <CPN.Icon type="more" className="fs20 cursorPointer" />
            </Dropdown>
        </Fragment>
    )
};

export const MfaStatus = ({ enabled }) => (
    <CPN.Tag color={enabled ? 'green' : undefined} style={{ borderRadius: 12, marginRight: 0 }}>
        <CPN.Badge status={enabled ? 'success' : 'default'} />
        {enabled ? 'ON' : 'OFF'}
    </CPN.Tag>
);

export const ForceMfaControl = ({ checked, loading, disabled, onChange }) => {
    const { t } = useTranslation();
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <CPN.Switch
                checked={checked}
                loading={loading}
                disabled={disabled || loading}
                onChange={onChange}
            />
            <span style={{ color: checked ? '#389e0d' : '#8c8c8c' }}>
                {checked ? t('item.user.forceMfaOn') : t('item.user.forceMfaOff')}
            </span>
        </div>
    );
};
